import { PERMISSION_MODEL } from '@sp/feature/permissions';
import { AppRouter } from '@sp/feature/routes';
import { useNativeKeyboardCb } from '@sp/util/viewport';
import { useEffect } from 'react';
import { NativeAppGuard } from './native-app-guard';
import './styles/styles.pcss';

export function App() {
  useEffect(() => {
    PERMISSION_MODEL.permissionChecked();
    const interval = setInterval(() => PERMISSION_MODEL.permissionChecked(), 4000);
    return () => clearInterval(interval);
  }, []);

  useNativeKeyboardCb();

  return (
    <NativeAppGuard>
      <AppRouter />
    </NativeAppGuard>
  );
}
